/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "1.15.5",
  "gitBuildTime": "2024-03-26T16:54:18.093Z",
  "gitBuildVersion": "1.15.5",
  "gitCommitId": "ae87da6",
  "gitCommitIdFull": "ae87da6c309a8e3ab8d3a69b22a27c49c7c4c00c",
  "gitCommitTime": "2024-03-26T16:52:58.000Z",
  "version": "1.15.5-2024-03-26T16:52:58.000Z-(ae87da6)"
};
